<template>
  <div class="app-container">
    <CommonViewForm :enter="false" is-edit @reFresh="reFresh" />
  </div>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import CommonViewForm from '../../components/CommonViewForm.vue';
export default {
  name: 'BusinessPurchaseReturnInformEdit',
  components: { CommonViewForm },
  mixins: [viewMiXin],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    reFresh() {
      this.complete('BusinessPurchaseReturnInform');
    },
  },
};
</script>
